<template>
  <div>
    <div v-if="sidebarOpen" class="sidebar-overlay d-md-none" @click="sidebarOpen = false"></div>
    <div class="sidebar sidebar-dark-pickled-bluewood" :class="{ 'sidebar-open': sidebarOpen }">
      <div class="sidebar-inner">
        <div class="sidebar-heading">Home</div>
        <sidebar-menu :menu="menuHome" class="mb-24pt" />

        <template v-if="isSuperAdmin">
          <div class="sidebar-heading">Admin</div>
          <sidebar-menu :menu="menuAdmin" class="mb-24pt" />
        </template>

        <div class="sidebar-heading">Marketing</div>
        <sidebar-menu :menu="menuMarketing" class="mb-24pt" />

        <div class="sidebar-heading">Tools</div>
        <sidebar-menu :menu="menuTools" class="mb-24pt" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { USER_ROLES } from '../../common/constants';
import SidebarMenu from './SidebarMenu.vue';

export default {
  name: 'Sidebar',
  components: { SidebarMenu },
  data() {
    return {
      sidebarOpen: false,
    };
  },
  watch: {
    $route() {
      this.sidebarOpen = false;
    },
  },
  mounted() {
    this.$root.$on('toggle-sidebar', () => {
      this.sidebarOpen = !this.sidebarOpen;
    });
  },
  beforeDestroy() {
    this.$root.$off('toggle-sidebar');
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isSuperAdmin() {
      return this.getLoggedInUser && this.getLoggedInUser.role === USER_ROLES.SUPER_ADMIN;
    },
    menuHome() {
      return [
        { label: 'Home', route: { name: 'dashboard' }, icon: 'home' },
        { label: 'Contacts', route: { name: 'contacts-list' }, icon: 'people' },
      ];
    },
    menuAdmin() {
      return [
        { label: 'Schools', route: { name: 'manage-schools' }, icon: 'account_balance' },
        { label: 'Users', route: { name: 'manage-users' }, icon: 'group' },
      ];
    },
    menuMarketing() {
      return [
        {
          label: 'Email', icon: 'email', children: [
            { label: 'Templates', route: { name: 'email-templates-list' } },
            { label: 'Campaigns', route: { name: 'campaigns-list' } },
            { label: 'Quick Send', route: { name: 'email-send' } },
            { label: 'Logs', route: { name: 'email-logs' } },
          ],
        },
        {
          label: 'SMS', icon: 'textsms', children: [
            { label: 'Templates', route: { name: 'sms-templates-list' } },
            { label: 'Campaigns', route: { name: 'sms-campaigns-list' } },
            { label: 'Quick Send', route: { name: 'sms-send' } },
            { label: 'Inbox', route: { name: 'sms-log' } },
          ],
        },
        { label: 'Automations', route: { name: 'automations-list' }, icon: 'bolt' },
      ];
    },
    menuTools() {
      return [
        {
          label: 'Contracts', icon: 'assignment', children: [
            { label: 'Templates', route: { name: 'contract-templates-list' } },
            { label: 'Contracts', route: { name: 'contracts-list' } },
          ],
        },
        { label: 'Surveys', route: { name: 'surveys-list' }, icon: 'poll' },
      ];
    },
  },
};
</script>
